import React from "react";
import { GoalColumnIcon } from "./goal-column-icons";
import { MetricBar } from "./metric-bar";

interface GoalTileContent {
    icon: GoalColumnIcon;
    label: string;
    barColor: string;
    actual: number;
    target: number;
    frac: number;
    footer: React.ReactNode;
}

const GoalTileBody: React.FC<GoalTileContent> = ({
    icon: Icon,
    label,
    barColor,
    actual,
    target,
    frac,
    footer,
}) => (
    <>
        <div className="flex items-center gap-1.5">
            <Icon aria-hidden="true" className="h-4 w-4 flex-shrink-0 text-gray-500" />
            <span className="truncate text-xs font-semibold text-zinc-800">{label}</span>
        </div>
        <div className="mt-1.5 flex items-baseline gap-1">
            <span className="text-xl font-bold leading-none tabular-nums text-zinc-950">
                {actual}
            </span>
            <span className="text-xs text-gray-500">/ {target}</span>
        </div>
        <div className="mt-2">
            <MetricBar
                actual={actual}
                target={target}
                bar={barColor}
                frac={frac}
                height="h-1.5"
            />
        </div>
        <div className="mt-1.5 text-[11px] text-gray-500">{footer}</div>
    </>
);

export const GoalSummaryTile: React.FC<GoalTileContent> = props => (
    <div className="min-w-0 rounded-lg bg-white px-3 py-2.5 ring-1 ring-gray-200">
        <GoalTileBody {...props} />
    </div>
);

interface GoalFilterTileProps extends GoalTileContent {
    selected: boolean;
    onToggle: () => void;
}

export const GoalFilterTile: React.FC<GoalFilterTileProps> = ({
    selected,
    onToggle,
    ...content
}) => (
    <button
        type="button"
        aria-pressed={selected}
        onClick={onToggle}
        className={`min-w-0 rounded-lg px-3 py-2.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-500 ${
            selected
                ? "bg-brand-100 ring-2 ring-brand-600"
                : "bg-white ring-1 ring-gray-200 hover:bg-gray-50 hover:ring-gray-300"
        }`}>
        <GoalTileBody {...content} />
    </button>
);
